export var TrackedLevels = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 20, 30];



//////////////////
// WEBPACK FOOTER
// ./src/constants/TrackedLevels.ts
// module id = 1887
// module chunks = 3